import React from 'react'
import {TableFilterRow} from '@devexpress/dx-react-grid-material-ui';
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
  DateRange as DateRangeIcon,
} from '@material-ui/icons';
import PropTypes from 'prop-types';

export const filterMessages = {
  before: 'Before',
  after: 'After',
  month: 'Month equals',
  year: 'Year equals',
  dateEquals: 'Date equals',
};

export const FilterIcon = ({type, ...restProps}) =>
  type === 'dateEquals' || type === 'year' || type === 'month' ? (
    <DateRangeIcon {...restProps} />
  ) : type === 'before' ? (
    <ChevronLeftIcon {...restProps} />
  ) : type === 'after' ? (
    <ChevronRightIcon {...restProps} />
  ) : (
    <TableFilterRow.Icon type={type} {...restProps} />
  );
FilterIcon.propTypes = {
  type: PropTypes.string,
};
